import { render, staticRenderFns } from "./FormData.vue?vue&type=template&id=363fc9d6&scoped=true&"
import script from "./FormData.vue?vue&type=script&lang=js&"
export * from "./FormData.vue?vue&type=script&lang=js&"
import style0 from "./FormData.vue?vue&type=style&index=0&id=363fc9d6&prod&lang=scss&"
import style1 from "./FormData.vue?vue&type=style&index=1&id=363fc9d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363fc9d6",
  null
  
)

export default component.exports